module.exports = function(bh) {
  bh.match('custom-file__inner', function(ctx, json) {
    ctx.tag('label')
      .attr('for', ctx.tParam('custom-file-id'));
  });
};
